module.exports = __webpack_public_path__ + "img/IN.69b796ab.svg";